import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { AppVideoPlayerPage } from './app-video-player';
import {PipesModule} from "../../pipes/pipes.module";
import {DirectivesModule} from "../../directives/directives.module";

@NgModule({
  declarations: [
    AppVideoPlayerPage,
  ],
  imports: [
    IonicPageModule.forChild(AppVideoPlayerPage),
    PipesModule,
    DirectivesModule,

  ],
})
export class AppVideoPlayerPageModule {}



// WEBPACK FOOTER //
// ./src/pages/app-video-player/app-video-player.module.ts